import { PartnerProgramService } from '@/services/partner-program.service';
import type { PartnerInviteDetailsResponse } from '@/services/partner-program.service';
import { useQuery } from '@tanstack/react-query';

export const useFetchPartnerInvite = (id: string) => {
  const {
    data: product,
    error,
    isPending,
  } = useQuery<PartnerInviteDetailsResponse>({
    queryKey: [`get-partner-invite-${id}`],
    queryFn: async () => PartnerProgramService.getInvitePartnerProgramById(id),
    enabled: !!id,
  });

  return { product, error, isPending };
};
